import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { FiltroControllerService } from 'src/app/services/filtro-controller.service';
import { ApiCorretoraService } from 'src/app/services/api-corretora.service';
import { CommonModule } from '@angular/common';
import { ModulosDeFormulario } from 'src/app/utils/formsModules';

@Component({
    selector: 'filtro-config-usuarios',
    templateUrl: './config-usuarios.component.html',
    styleUrls: ['./config-usuarios.component.scss'],    
    imports: [CommonModule, ModulosDeFormulario],
})
export class ConfigUsuariosComponent implements OnInit {
  @Output('eventFilter') eventFilter = new EventEmitter();
  @Output('clearFilter') limpaFiltro = new EventEmitter();
	@Input('gruposPermissoes') gruposPermissoes: any;
  filtroPermissoes = [];
  filtroPermissoesExpandido = true;
  constructor(public filtroController: FiltroControllerService, public corretoraService: ApiCorretoraService) { }

  ngOnInit() {
    this.inicializaFiltros();
  }

  buildString() {
    this.filtroController.addFiltrosExtras('usuarios', this.filtroPermissoes.length ? 
    { permissoes: this.filtroPermissoes } : 0);
    let rawValue = {
      permissoes: this.filtroController.filtroUsuarios.permissoes
    };
    let filtros = { values: rawValue };
    this.eventFilter.emit(filtros);
    this.filtroController.verificaFiltro();
    return filtros;
  }

  clearFilter() {
    this.filtroPermissoes = [];
    this.limpafiltroPermissoes();
    this.filtroController.limparFiltro('usuarios');
    this.limpaFiltro.emit();
    this.filtroController.verificaFiltro();
    this.buildString();
  }

  async inicializaFiltros(){
    if(this.filtroController.filtroUsuarios){
      this.filtroPermissoes = this.filtroController.filtroUsuarios.permissoes;
      this.verificaPermissoesSelecionadas();
    }
  }

  atualizafiltroPermissoes(grupoId, newValue) {
    for (let grupos of this.gruposPermissoes) {
      if (grupos.id == grupoId) {
        if (newValue) {
          this.filtroPermissoes.push(grupoId);
        } else {
          let index = this.filtroPermissoes.findIndex(s => s == grupoId);
          this.filtroPermissoes.splice(index, 1);
        }
      }
    }

    this.filtroController.updateActiveFilters("config-usuario", this.filtroPermissoes.length);
  }

  limpafiltroPermissoes() {
    this.filtroPermissoes = [];
    for(let item of this.gruposPermissoes) {
      item['ativo'] = false;
    }
  }

  verificaPermissoesSelecionadas() {
		for (let item of this.gruposPermissoes) {
			for (let id of this.filtroPermissoes) {
				if (item.id === id) {
					item['ativo'] = true;
				}
			}
		}
	}
}